export default __webpack_public_path__ + "static/media/diwala_logo.040b6d3e.svg";